export default __webpack_public_path__ + "static/media/count3.3736509c.wav";